import { useEffect, useState } from "react";
import api, { nzISODate } from "@/lib/api";
import WeatherChipRow from "@/components/WeatherChipRow";
import Field from "@/components/Field";
import DateInput from "@/components/DateInput";
import AwayStrip from "@/components/AwayStrip";

export default function WorksProgramme() {
  const monday = (() => {
    const d = new Date(`${nzISODate()}T00:00:00Z`); const day = d.getUTCDay() || 7; d.setUTCDate(d.getUTCDate() - (day - 1));
    return d.toISOString().slice(0, 10);
  })();
  const [weekStart, setWeekStart] = useState(monday);
  const [prog, setProg] = useState({ schedule: [], weather: [], job_notes: [], action_items: [], subcontractors: [] });
  const [sendStatus, setSendStatus] = useState("");
  const [overview, setOverview] = useState(null);

  async function load() {
    const { data } = await api.get("/works-programme", { params: { week_start: weekStart } });
    setProg(data);
  }
  async function loadOverview() {
    try {
      const { data } = await api.get("/home-base/projects-overview");
      setOverview(data);
    } catch { setOverview({ rows: [] }); }
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [weekStart]);
  useEffect(() => { loadOverview(); }, []);

  async function save() { await api.put("/works-programme", { ...prog, week_start: weekStart }); alert("Programme saved"); }
  async function send() {
    const { data } = await api.post("/works-programme/send", { week_start: weekStart });
    setSendStatus(data.status === "sent" ? "Sent to Luke." : `Setup pending — ${data.message||""}`);
  }

  return (
    <div className="space-y-3" data-testid="programme-page">
      <h1 className="text-2xl">Works Programme</h1>
      <AwayStrip />
      <div className="card flex gap-2 items-end flex-wrap">
        <Field label="Week starting" hint="Monday (DD/MM/YYYY)">
          <DateInput className="input" placeholder="Week starting (Monday)" value={weekStart} onChange={e=>setWeekStart(e.target.value)}/>
        </Field>
        <button className="btn-silver" onClick={save}>Save</button>
        <button className="btn-ghost" onClick={send} data-testid="btn-send-programme">Send to Luke</button>
        {sendStatus && <span className="text-sm text-silver">{sendStatus}</span>}
      </div>
      <div className="card">
        <h2 className="text-silver mb-2">Action items</h2>
        <Field label="Action items" hint="One per line">
          <textarea className="input" rows={4} placeholder="One action item per line" value={(prog.action_items||[]).join("\n")} onChange={e=>setProg({...prog,action_items:e.target.value.split("\n")})}/>
        </Field>
      </div>
      <div className="card" data-testid="works-weather-section">
        <h2 className="text-silver mb-2 text-sm">Weather — home base + out-of-town sites</h2>
        {!overview ? (
          <div className="opacity-60 text-sm">Loading forecasts…</div>
        ) : overview.rows.length === 0 ? (
          <div className="opacity-60 text-sm">No forecasts available.</div>
        ) : (
          <div className="space-y-2">
            {overview.rows.map((row, i) => (
              <div key={i} data-testid={row.scope === "home_base" ? "works-weather-home-base" : `works-weather-project-${row.project_id}`}>
                <WeatherChipRow label={row.label} days={row.days} testid={`works-chip-${i}`}/>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
